import { LoadingDirectiveModule } from '@shared/loading-directive/loading-directive.module';
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {FuseSharedModule} from '@fuse/shared.module';
import {Login2Component} from '@app/components/login/login-2.component';
import {TranslateModule} from '@ngx-translate/core';
import {MatCardModule} from '@angular/material/card';
import {TestFlagsComponent} from '../../../@shared/test-flags/test-flags.component';
import {MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

const routes: Routes = [

];

@NgModule({
  declarations: [

    Login2Component,

  ],
    imports: [
        MatButtonModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        FuseSharedModule,
        TranslateModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatCardModule,
        TestFlagsComponent,
        LoadingDirectiveModule
    ],
  exports: [
    // RouterModule,
    Login2Component,
  ]
})
export class Login2Module {
}
